var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Box, Button, CircularProgress, Grid, Stack, Tooltip, Typography } from '@mui/material';
import CloudDownloadOutlinedIcon from '@mui/icons-material/CloudDownloadOutlined';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import SafetyCheckIcon from '@mui/icons-material/SafetyCheck';
import RemoveModeratorOutlinedIcon from '@mui/icons-material/RemoveModeratorOutlined';
import React, { useEffect, useRef, useState } from 'react';
import AutoCompleteDD from '../../components/FormComponents/AutoCompleteDD';
import { api_service } from '../../api/api_service';
import { api_urls } from '../../api/api_urls';
import { utility } from '../../utils';
import constants from '../../config/constants';
import { getCommaSeparatedForAmounts, convertStringValuesToNumbers } from '../../utils/commonUtilities';
import { TruncatedTooltipText } from '../../components/uiComponents/TruncatedTooltipText';
import ConfirmationAndInformationPoup, { POPUP_TYPE } from '../../components/UtilityComponents/ConfirmationAndInformationPoup';
import TabSectionCard, { DataWrapper } from './components/TabSectionCard';
import { RESPONSIVE_FIELD_GRID_SX } from './utils/responsiveGrid';
var CONSENT_OPTIONS = [
    { Name: 'No', OId: 0 },
    { Name: 'Yes', OId: 1 },
];
var isEmptyValue = function (value) { return value === undefined || value === null || String(value).trim() === ''; };
var firstFilled = function () {
    var values = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        values[_i] = arguments[_i];
    }
    return values.find(function (value) { return !isEmptyValue(value); });
};
var AUTO_GENERATED_NOTE = 'Note: Insurance Quote ID, Quotation Amount and Enrollment ID are auto-generated and cannot be edited.';
var GET_ENROLLMENT_TOOLTIP = 'Coverage has been requested for this booked application. Click "Get Enrollment ID" to complete it and mark the coverage as accepted.';
var pickEnrollmentId = function (data) {
    if (typeof data === 'string' || typeof data === 'number')
        return String(data).trim();
    var key = Object.keys(data !== null && data !== void 0 ? data : {}).find(function (name) { return name.toLowerCase().replace(/^insurance/, '') === 'enrollmentid' || name.toLowerCase() === 'insuranceenrollment'; });
    var found = key ? data[key] : undefined;
    return isEmptyValue(found) ? '' : String(found).trim();
};
var CONSENT_ALIASES = { true: 1, y: 1, yes: 1, false: 0, n: 0, no: 0 };
var findConsentOption = function (value) {
    if (isEmptyValue(value))
        return undefined;
    var key = String(value).trim().toLowerCase();
    return CONSENT_OPTIONS.find(function (option) { return String(option.OId) === key || option.Name.toLowerCase() === key || option.OId === CONSENT_ALIASES[key]; });
};
var ConsentTag = function (_a) {
    var consent = _a.consent, quoteId = _a.quoteId, enrollmentId = _a.enrollmentId;
    var yes = String(consent) === '1';
    var no = String(consent) === '0';
    if (!yes && !no)
        return null;
    var accepted = yes && !isEmptyValue(quoteId) && !isEmptyValue(enrollmentId);
    var tone = yes
        ? { bg: 'linear-gradient(135deg, #E6F4E1 0%, #CFEAC8 100%)', color: '#3C7A2E' }
        : { bg: 'linear-gradient(135deg, #FBE9E8 0%, #F5D3D1 100%)', color: '#A5443E' };
    return (React.createElement(Box, { sx: {
            display: 'inline-flex',
            alignItems: 'center',
            gap: 0.75,
            px: 1.5,
            py: 0.5,
            borderRadius: '16px',
            background: tone.bg,
            color: tone.color,
            fontSize: 13,
            fontWeight: 600,
            whiteSpace: 'nowrap',
            '& svg': { fontSize: 18 },
        } },
        no ? React.createElement(RemoveModeratorOutlinedIcon, null) : accepted ? React.createElement(VerifiedUserIcon, null) : React.createElement(SafetyCheckIcon, null),
        no ? 'Coverage Denied' : accepted ? 'Coverage Accepted' : 'Coverage Requested'));
};
var InsuranceManagement = function (_a) {
    var TxAspireOId = _a.TxAspireOId, _roleType = _a.roleType, hasEditAccess = _a.hasEditAccess, _b = _a.editOnlyWithoutConsent, editOnlyWithoutConsent = _b === void 0 ? false : _b, _c = _a.isBooked, isBooked = _c === void 0 ? false : _c, mainResp = _a.mainResp, assetResp = _a.assetResp, onLoadAssets = _a.onLoadAssets, onDataRefresh = _a.onDataRefresh, onSilentRefresh = _a.onSilentRefresh;
    var _d = useState([]), insuranceData = _d[0], setInsuranceData = _d[1];
    var _e = useState(null), editingIndex = _e[0], setEditingIndex = _e[1];
    var _f = useState(null), formValues = _f[0], setFormValues = _f[1];
    var _g = useState({}), generatedEnrollment = _g[0], setGeneratedEnrollment = _g[1];
    var _h = useState(null), fetchingEnrollmentIndex = _h[0], setFetchingEnrollmentIndex = _h[1];
    var enrollmentRequestInFlightRef = useRef(false);
    var _j = useState(null), pendingSave = _j[0], setPendingSave = _j[1];
    var generatedQuoteRef = useRef(null);
    var getInsuranceManagementInfo = function (silent) {
        if (silent === void 0) { silent = false; }
        return __awaiter(void 0, void 0, void 0, function () {
            var payload, response, resp, records, error_1;
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _c.trys.push([0, 2, , 3]);
                        payload = {
                            TxAspireOId: TxAspireOId
                        };
                        return [4, api_service.get({
                                endPoint: api_urls.GET_INSURANCE_DETAILS,
                                payLoad: payload,
                                showLoader: !silent,
                            })];
                    case 1:
                        response = _c.sent();
                        if (response.data && response.data.statusCode === 200) {
                            resp = (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.data;
                            records = Array.isArray(resp) ? resp : [];
                            setInsuranceData(records.filter(function (record) { var _a; return /great american/i.test(String((_a = record === null || record === void 0 ? void 0 : record.InsuranceIntegration) !== null && _a !== void 0 ? _a : '')); }));
                        }
                        else {
                            utility.alert((_b = response === null || response === void 0 ? void 0 : response.data) === null || _b === void 0 ? void 0 : _b.message, constants.TOAST_TYPES.ERROR);
                        }
                        return [3, 3];
                    case 2:
                        error_1 = _c.sent();
                        utility.alert(error_1, constants.TOAST_TYPES.ERROR);
                        console.log('Error:', error_1);
                        return [3, 3];
                    case 3: return [2];
                }
            });
        });
    };
    useEffect(function () {
        if (TxAspireOId) {
            getInsuranceManagementInfo();
        }
    }, [TxAspireOId]);
    var udfs = mainResp === null || mainResp === void 0 ? void 0 : mainResp.UDFsData;
    var getValues = function (insurance) {
        var _a, _b, _c, _d, _e, _f;
        return ({
            InsuranceConsent: (_c = (_b = (_a = findConsentOption(firstFilled(insurance === null || insurance === void 0 ? void 0 : insurance.InsuranceConsent, udfs === null || udfs === void 0 ? void 0 : udfs.InsuranceConsent))) === null || _a === void 0 ? void 0 : _a.OId) !== null && _b !== void 0 ? _b : firstFilled(insurance === null || insurance === void 0 ? void 0 : insurance.InsuranceConsent, udfs === null || udfs === void 0 ? void 0 : udfs.InsuranceConsent)) !== null && _c !== void 0 ? _c : '',
            InsuranceQuoteID: String((_d = firstFilled(insurance === null || insurance === void 0 ? void 0 : insurance.InsuranceQuoteID, udfs === null || udfs === void 0 ? void 0 : udfs.InsuranceQuoteID)) !== null && _d !== void 0 ? _d : ''),
            InsuranceEnrollment: String((_e = firstFilled(insurance === null || insurance === void 0 ? void 0 : insurance.InsuranceEnrollment, udfs === null || udfs === void 0 ? void 0 : udfs.InsuranceEnrollment)) !== null && _e !== void 0 ? _e : ''),
            InsuranceQuotationAmount: String((_f = firstFilled(insurance === null || insurance === void 0 ? void 0 : insurance.InsuranceQuotationAmount, udfs === null || udfs === void 0 ? void 0 : udfs.InsuranceQuotationAmount)) !== null && _f !== void 0 ? _f : ''),
        });
    };
    var startEdit = function (index, insurance) {
        generatedQuoteRef.current = null;
        setFormValues(getValues(insurance));
        setEditingIndex(index);
    };
    var cancelEdit = function () {
        generatedQuoteRef.current = null;
        setEditingIndex(null);
        setFormValues(null);
    };
    var buildQuoteRequest = function (assetDetails) {
        var _a, _b, _c, _d, _e;
        var contract = mainResp === null || mainResp === void 0 ? void 0 : mainResp.ContractData;
        var customers = Array.isArray((_a = mainResp === null || mainResp === void 0 ? void 0 : mainResp.RelatedAccounts) === null || _a === void 0 ? void 0 : _a.CustomerInfo) ? mainResp.RelatedAccounts.CustomerInfo : [];
        var customer = (_c = (_b = customers.find(function (acc) { return (acc === null || acc === void 0 ? void 0 : acc.IsPrimary) === 1 || (acc === null || acc === void 0 ? void 0 : acc.IsPrimary) === '1' || (acc === null || acc === void 0 ? void 0 : acc.IsPrimary) === true; })) !== null && _b !== void 0 ? _b : customers[0]) !== null && _c !== void 0 ? _c : {};
        var assets = Array.isArray(assetDetails === null || assetDetails === void 0 ? void 0 : assetDetails.Assets) ? assetDetails.Assets : [];
        var customerName = (_d = firstFilled(customer.BusinessName, customer.CustomerName, customer.Name)) !== null && _d !== void 0 ? _d : [customer.FirstName, customer.LastName].filter(function (part) { return !isEmptyValue(part); }).join(' ');
        return {
            ContractAspireId: contract === null || contract === void 0 ? void 0 : contract.ContractAspireId,
            TxAspireOId: (_e = contract === null || contract === void 0 ? void 0 : contract.TxAspireOId) !== null && _e !== void 0 ? _e : TxAspireOId,
            Term: Number(convertStringValuesToNumbers(contract === null || contract === void 0 ? void 0 : contract.Term)),
            IsLoan: (contract === null || contract === void 0 ? void 0 : contract.IsLoan) === true ? 1 : 0,
            ProgramAspireOId: contract === null || contract === void 0 ? void 0 : contract.ProgramAspireOId,
            FinanceCompanyOId: firstFilled(contract === null || contract === void 0 ? void 0 : contract.FinanceCompanyAspireId, contract === null || contract === void 0 ? void 0 : contract.FinanceCompanyOId),
            CustomerInfo: {
                Name: customerName,
                Email: customer.Email,
                PhoneNumber: customer.PhoneNumber,
                Country: customer.Country,
                State: customer.State,
                City: customer.City,
                PostalCode: customer.PostalCode,
                Address: customer.Address,
                CustomerAspireOId: customer.CustomerAspireOId,
            },
            AssetInfo: assets.map(function (asset) { return ({
                AssetAspireOId: asset === null || asset === void 0 ? void 0 : asset.AssetAspireOId,
                Quantity: asset === null || asset === void 0 ? void 0 : asset.Quantity,
                EquipmentCost: Number(convertStringValuesToNumbers(firstFilled(asset === null || asset === void 0 ? void 0 : asset.UnitAmount, asset === null || asset === void 0 ? void 0 : asset.EquipmentCost))),
                EquipmentType: asset === null || asset === void 0 ? void 0 : asset.EquipmentTypeDescription
            }); }),
        };
    };
    var handleConsentChange = function (e) {
        var _a, _b;
        var raw = e.target.value;
        var value = (_b = (_a = findConsentOption(raw)) === null || _a === void 0 ? void 0 : _a.OId) !== null && _b !== void 0 ? _b : raw;
        generatedQuoteRef.current = null;
        if (String(value) !== '1') {
            setFormValues(function (prev) { return (prev ? __assign(__assign({}, prev), { InsuranceConsent: value, InsuranceQuoteID: '', InsuranceEnrollment: '', InsuranceQuotationAmount: '' }) : prev); });
            return;
        }
        setFormValues(function (prev) { return (prev ? __assign(__assign({}, prev), { InsuranceConsent: value }) : prev); });
    };
    var requestQuote = function () { return __awaiter(void 0, void 0, void 0, function () {
        var assetDetails, response, quote, error_2;
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    _d.trys.push([0, 4, , 5]);
                    assetDetails = assetResp;
                    if (!(!Array.isArray(assetDetails === null || assetDetails === void 0 ? void 0 : assetDetails.Assets) && onLoadAssets)) return [3, 2];
                    return [4, onLoadAssets()];
                case 1:
                    assetDetails = _d.sent();
                    _d.label = 2;
                case 2:
                    if (!Array.isArray(assetDetails === null || assetDetails === void 0 ? void 0 : assetDetails.Assets) || assetDetails.Assets.length === 0) {
                        utility.alert('Unable to generate the insurance quote: the application\'s assets could not be loaded.', constants.TOAST_TYPES.ERROR);
                        return [2, null];
                    }
                    return [4, api_service.post({
                            endPoint: api_urls.GENERATE_INSURANCE_QUOTE,
                            payLoad: buildQuoteRequest(assetDetails),
                            showLoader: true,
                        })];
                case 3:
                    response = _d.sent();
                    quote = (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.data;
                    if (((_b = response === null || response === void 0 ? void 0 : response.data) === null || _b === void 0 ? void 0 : _b.statusCode) === 200 && !isEmptyValue(quote === null || quote === void 0 ? void 0 : quote.InsuranceQuoteId)) {
                        return [2, {
                                quoteId: String(quote.InsuranceQuoteId).trim(),
                                amount: isEmptyValue(quote === null || quote === void 0 ? void 0 : quote.InsuranceQuoteAmount) ? null : Number(convertStringValuesToNumbers(quote.InsuranceQuoteAmount)),
                            }];
                    }
                    utility.alert(((_c = response === null || response === void 0 ? void 0 : response.data) === null || _c === void 0 ? void 0 : _c.message) || 'Unable to generate the insurance quote.', constants.TOAST_TYPES.ERROR);
                    return [3, 5];
                case 4:
                    error_2 = _d.sent();
                    utility.alert('Unable to generate the insurance quote.', constants.TOAST_TYPES.ERROR);
                    console.log('Error:', error_2);
                    return [3, 5];
                case 5: return [2, null];
            }
        });
    }); };
    var fetchEnrollmentId = function (index, quoteId) { return __awaiter(void 0, void 0, void 0, function () {
        var response, enrollmentId_1, error_3;
        var _a, _b, _c, _d, _e, _f;
        return __generator(this, function (_g) {
            switch (_g.label) {
                case 0:
                    if (enrollmentRequestInFlightRef.current || fetchingEnrollmentIndex !== null)
                        return [2];
                    enrollmentRequestInFlightRef.current = true;
                    setFetchingEnrollmentIndex(index);
                    _g.label = 1;
                case 1:
                    _g.trys.push([1, 8, 9, 10]);
                    return [4, api_service.get({
                            endPoint: api_urls.GET_INSURANCE_ENROLLMENT,
                            payLoad: { QuoteId: quoteId, ContractAspireId: (_a = mainResp === null || mainResp === void 0 ? void 0 : mainResp.ContractData) === null || _a === void 0 ? void 0 : _a.ContractAspireId, TxAspireOId: (_c = (_b = mainResp === null || mainResp === void 0 ? void 0 : mainResp.ContractData) === null || _b === void 0 ? void 0 : _b.TxAspireOId) !== null && _c !== void 0 ? _c : TxAspireOId },
                            showLoader: false,
                        })];
                case 2:
                    response = _g.sent();
                    enrollmentId_1 = ((_d = response === null || response === void 0 ? void 0 : response.data) === null || _d === void 0 ? void 0 : _d.statusCode) === 200 ? pickEnrollmentId((_e = response === null || response === void 0 ? void 0 : response.data) === null || _e === void 0 ? void 0 : _e.data) : '';
                    if (!enrollmentId_1) return [3, 6];
                    setGeneratedEnrollment(function (prev) {
                        var _a;
                        return (__assign(__assign({}, prev), (_a = {}, _a[index] = enrollmentId_1, _a)));
                    });
                    if (!onSilentRefresh) return [3, 4];
                    return [4, onSilentRefresh()];
                case 3:
                    _g.sent();
                    _g.label = 4;
                case 4: return [4, getInsuranceManagementInfo(true)];
                case 5:
                    _g.sent();
                    return [3, 7];
                case 6:
                    utility.alert(((_f = response === null || response === void 0 ? void 0 : response.data) === null || _f === void 0 ? void 0 : _f.message) || 'Enrollment ID is not available yet.', constants.TOAST_TYPES.ERROR);
                    _g.label = 7;
                case 7: return [3, 10];
                case 8:
                    error_3 = _g.sent();
                    utility.alert('Unable to get the Enrollment ID.', constants.TOAST_TYPES.ERROR);
                    console.log('Error:', error_3);
                    return [3, 10];
                case 9:
                    enrollmentRequestInFlightRef.current = false;
                    setFetchingEnrollmentIndex(null);
                    return [7];
                case 10: return [2];
            }
        });
    }); };
    var handleSave = function (insurance) { return __awaiter(void 0, void 0, void 0, function () {
        var original, changes, quote, _a, response, error_4;
        var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        return __generator(this, function (_m) {
            switch (_m.label) {
                case 0:
                    if (!formValues)
                        return [2];
                    original = getValues(insurance);
                    changes = {};
                    if (String(formValues.InsuranceConsent) !== String(original.InsuranceConsent)) {
                        changes.InsuranceConsent = formValues.InsuranceConsent === '' ? null : formValues.InsuranceConsent;
                    }
                    if (formValues.InsuranceQuoteID !== original.InsuranceQuoteID) {
                        changes.InsuranceQuoteID = isEmptyValue(formValues.InsuranceQuoteID) ? null : formValues.InsuranceQuoteID.trim();
                    }
                    if (formValues.InsuranceQuotationAmount !== original.InsuranceQuotationAmount) {
                        changes.InsuranceQuotationAmount = isEmptyValue(formValues.InsuranceQuotationAmount) ? null : Number(convertStringValuesToNumbers(formValues.InsuranceQuotationAmount));
                    }
                    if (String(formValues.InsuranceConsent) === '0' && !isEmptyValue(original.InsuranceEnrollment)) {
                        changes.InsuranceEnrollment = null;
                    }
                    if (!(String(formValues.InsuranceConsent) === '1' && (String(original.InsuranceConsent) !== '1' || isEmptyValue(original.InsuranceQuoteID)))) return [3, 4];
                    if (!((_b = generatedQuoteRef.current) !== null && _b !== void 0)) return [3, 1];
                    _a = _b;
                    return [3, 3];
                case 1: return [4, requestQuote()];
                case 2:
                    _a = _m.sent();
                    _m.label = 3;
                case 3:
                    quote = _a;
                    if (!quote)
                        return [2];
                    generatedQuoteRef.current = quote;
                    changes.InsuranceConsent = formValues.InsuranceConsent;
                    changes.InsuranceQuoteID = quote.quoteId;
                    changes.InsuranceQuotationAmount = quote.amount;
                    _m.label = 4;
                case 4:
                    if (Object.keys(changes).length === 0) {
                        cancelEdit();
                        return [2];
                    }
                    _m.label = 5;
                case 5:
                    _m.trys.push([5, 12, , 13]);
                    return [4, api_service.put({
                            endPoint: api_urls.UPDATE_BACKLOG_UDFS,
                            payLoad: __assign(__assign({ ContractAspireId: (_c = mainResp === null || mainResp === void 0 ? void 0 : mainResp.ContractData) === null || _c === void 0 ? void 0 : _c.ContractAspireId, ApplicationType: (_d = mainResp === null || mainResp === void 0 ? void 0 : mainResp.ContractData) === null || _d === void 0 ? void 0 : _d.ContractCategory, TxAspireOId: (_f = (_e = mainResp === null || mainResp === void 0 ? void 0 : mainResp.ContractData) === null || _e === void 0 ? void 0 : _e.TxAspireOId) !== null && _f !== void 0 ? _f : TxAspireOId }, (((_g = mainResp === null || mainResp === void 0 ? void 0 : mainResp.ContractData) === null || _g === void 0 ? void 0 : _g.ContractCategory) === 'SCH' && { LOCAspireOId: (_h = mainResp === null || mainResp === void 0 ? void 0 : mainResp.ContractData) === null || _h === void 0 ? void 0 : _h.LOCAspireOId })), changes),
                            showLoader: true,
                        })];
                case 6:
                    response = _m.sent();
                    if (!(((_j = response === null || response === void 0 ? void 0 : response.data) === null || _j === void 0 ? void 0 : _j.statusCode) === 200)) return [3, 10];
                    utility.alert((_k = response === null || response === void 0 ? void 0 : response.data) === null || _k === void 0 ? void 0 : _k.message, constants.TOAST_TYPES.INFO);
                    cancelEdit();
                    if (!onDataRefresh) return [3, 8];
                    return [4, onDataRefresh()];
                case 7:
                    _m.sent();
                    _m.label = 8;
                case 8: return [4, getInsuranceManagementInfo()];
                case 9:
                    _m.sent();
                    return [3, 11];
                case 10:
                    utility.alert((_l = response === null || response === void 0 ? void 0 : response.data) === null || _l === void 0 ? void 0 : _l.message, constants.TOAST_TYPES.ERROR);
                    _m.label = 11;
                case 11: return [3, 13];
                case 12:
                    error_4 = _m.sent();
                    utility.alert(error_4, constants.TOAST_TYPES.ERROR);
                    console.log('Error:', error_4);
                    return [3, 13];
                case 13: return [2];
            }
        });
    }); };
    var getSectionTitle = function (insurance, index) {
        var _a;
        var name = String((_a = insurance === null || insurance === void 0 ? void 0 : insurance.InsuranceIntegration) !== null && _a !== void 0 ? _a : '').trim();
        if (!name)
            return insuranceData.length > 1 ? "Insurance-".concat(index + 1) : 'Insurance';
        return /insurance/i.test(name) ? name : "".concat(name, " Insurance");
    };
    var renderReadOnly = function (label, value) { return (React.createElement(DataWrapper, { gap: 1 },
        React.createElement(Typography, { variant: "caption", className: "title" },
            label,
            ":"),
        React.createElement(TruncatedTooltipText, { value: value }))); };
    return (React.createElement(React.Fragment, null,
        React.createElement(ConfirmationAndInformationPoup, { popupType: POPUP_TYPE.UNSAVED_DATA_WARNING, titleText: "Save Changes", message: "Would you like to save the changes you\u2019ve made?", acceptBtnText: "Yes", denyBtnText: "No", open: pendingSave !== null, acceptCallBack: function () {
                var insurance = pendingSave;
                setPendingSave(null);
                if (insurance)
                    handleSave(insurance);
            }, denyCallBack: function () { return setPendingSave(null); }, cancelCallBack: function () { return setPendingSave(null); } }),
        React.createElement(Stack, { gap: 2 }, insuranceData === null || insuranceData === void 0 ? void 0 : insuranceData.map(function (insurance, index) {
            var _a;
            var isEditing = editingIndex === index && formValues !== null;
            var values = isEditing ? formValues : getValues(insurance);
            var original = getValues(insurance);
            var consentOption = findConsentOption(values.InsuranceConsent);
            var enrollmentValue = values.InsuranceEnrollment || generatedEnrollment[index] || '';
            var showEnrollmentIcon = isBooked && !isEditing && String(values.InsuranceConsent) === '1' && !isEmptyValue(values.InsuranceQuoteID);
            var consentDeclined = String(values.InsuranceConsent) === '0';
            var amountDisplay = isEmptyValue(values.InsuranceQuotationAmount) ? '--' : getCommaSeparatedForAmounts(values.InsuranceQuotationAmount);
            return (React.createElement(TabSectionCard, { key: index, title: getSectionTitle(insurance, index), showEditIcon: hasEditAccess && !isEditing && (!editOnlyWithoutConsent || isEmptyValue(original.InsuranceConsent) || String(original.InsuranceConsent) === '0'), onEditClick: function () { return startEdit(index, insurance); }, showSaveCancel: isEditing, onSave: function () { return setPendingSave(insurance); }, onCancel: cancelEdit, headerActions: React.createElement(ConsentTag, { consent: original.InsuranceConsent, quoteId: original.InsuranceQuoteID, enrollmentId: original.InsuranceEnrollment || generatedEnrollment[index] }) },
                React.createElement(Grid, { container: true, spacing: 2, alignItems: "end", sx: RESPONSIVE_FIELD_GRID_SX },
                    React.createElement(Grid, { item: true, xs: 4 }, isEditing ? (React.createElement(AutoCompleteDD, { options: CONSENT_OPTIONS, displayKey: "Name", valueKey: "OId", label: "Insurance Consent", placeholder: "Insurance Consent", handleChange: handleConsentChange, handleBlur: function () { }, selectedValue: consentOption !== null && consentOption !== void 0 ? consentOption : '', name: "InsuranceConsent", isMandatoryField: false, fontWeight: "600" })) : renderReadOnly('Insurance Consent', (_a = consentOption === null || consentOption === void 0 ? void 0 : consentOption.Name) !== null && _a !== void 0 ? _a : '--')),
                    React.createElement(Grid, { item: true, xs: 4 }, renderReadOnly('Insurance Quote ID', (!consentDeclined && values.InsuranceQuoteID) || '--')),
                    React.createElement(Grid, { item: true, xs: 4 }, renderReadOnly('Insurance Quotation Amount', consentDeclined ? '--' : amountDisplay)),
                    React.createElement(Grid, { item: true, xs: 4 },
                        React.createElement(DataWrapper, { gap: 1 },
                            React.createElement(Stack, { direction: "row", alignItems: "center", gap: 0.5 },
                                React.createElement(Typography, { variant: "caption", className: "title" }, "Insurance Enrollment ID:"),
                                showEnrollmentIcon && !enrollmentValue && (React.createElement(Tooltip, { title: GET_ENROLLMENT_TOOLTIP, arrow: true, placement: "top" },
                                    React.createElement(InfoOutlinedIcon, { "aria-label": GET_ENROLLMENT_TOOLTIP, sx: { fontSize: 15, color: 'text.secondary', cursor: 'default' } })))),
                            showEnrollmentIcon && !enrollmentValue ? (React.createElement(Box, { sx: { minHeight: 24, display: 'flex', alignItems: 'center' } },
                                React.createElement(Button, { size: "small", variant: "outlined", disabled: fetchingEnrollmentIndex !== null, onClick: function () { return fetchEnrollmentId(index, values.InsuranceQuoteID); }, startIcon: fetchingEnrollmentIndex === index ? React.createElement(CircularProgress, { size: 12 }) : React.createElement(CloudDownloadOutlinedIcon, { sx: { fontSize: '16px !important' } }), sx: { textTransform: 'none', fontWeight: 600, fontSize: 12, height: 24, borderRadius: '12px', px: 1.25, whiteSpace: 'nowrap' } }, fetchingEnrollmentIndex === index ? 'Getting Enrollment ID...' : 'Get Enrollment ID'))) : (React.createElement(TruncatedTooltipText, { value: enrollmentValue || '--' }))))),
                React.createElement(Stack, { direction: "row", alignItems: "center", gap: 0.75, sx: { mt: 2 } },
                    React.createElement(InfoOutlinedIcon, { sx: { fontSize: 16, color: 'text.secondary' } }),
                    React.createElement(Typography, { variant: "caption", color: "text.secondary" }, AUTO_GENERATED_NOTE))));
        }))));
};
export default InsuranceManagement;
